module.exports = __webpack_public_path__ + "static/media/guanjun.7a45ebeb.png";